import { ServiceRequestReason } from '#generated-types';

export const serviceRequestReasons = [
  { id: ServiceRequestReason.ExistingProblem, name: 'Existing problem' },
  { id: ServiceRequestReason.NewProblem, name: 'New problem' },
];
